/**
 * 日本の祝日データ(2026-08-28 会議 ■13)。外部API不使用・同梱データ方式。
 * 国民の祝日+振替休日を YYYY-MM-DD で保持する。
 * **年次更新**: 毎年12月頃に翌々年分を内閣府の「国民の祝日」一覧
 * (https://www8.cao.go.jp/chosei/shukujitsu/gaiyou.html)から追記する。
 * 手順は docs/OPERATIONS.md「祝日データの年次更新」を参照
 */
import type { DateStr } from './types';

/** 祝日 → 名称(2025〜2027年分を収録) */
export const JP_HOLIDAYS: Record<string, string> = {
  // ---- 2025年 ----
  '2025-01-01': '元日',
  '2025-01-13': '成人の日',
  '2025-02-11': '建国記念の日',
  '2025-02-23': '天皇誕生日',
  '2025-02-24': '振替休日',
  '2025-03-20': '春分の日',
  '2025-04-29': '昭和の日',
  '2025-05-03': '憲法記念日',
  '2025-05-04': 'みどりの日',
  '2025-05-05': 'こどもの日',
  '2025-05-06': '振替休日',
  '2025-07-21': '海の日',
  '2025-08-11': '山の日',
  '2025-09-15': '敬老の日',
  '2025-09-23': '秋分の日',
  '2025-10-13': 'スポーツの日',
  '2025-11-03': '文化の日',
  '2025-11-23': '勤労感謝の日',
  '2025-11-24': '振替休日',
  // ---- 2026年 ----
  '2026-01-01': '元日',
  '2026-01-12': '成人の日',
  '2026-02-11': '建国記念の日',
  '2026-02-23': '天皇誕生日',
  '2026-03-20': '春分の日',
  '2026-04-29': '昭和の日',
  '2026-05-03': '憲法記念日',
  '2026-05-04': 'みどりの日',
  '2026-05-05': 'こどもの日',
  '2026-05-06': '振替休日',
  '2026-07-20': '海の日',
  '2026-08-11': '山の日',
  '2026-09-21': '敬老の日',
  '2026-09-22': '国民の休日',
  '2026-09-23': '秋分の日',
  '2026-10-12': 'スポーツの日',
  '2026-11-03': '文化の日',
  '2026-11-23': '勤労感謝の日',
  // ---- 2027年 ----
  '2027-01-01': '元日',
  '2027-01-11': '成人の日',
  '2027-02-11': '建国記念の日',
  '2027-02-23': '天皇誕生日',
  '2027-03-21': '春分の日',
  '2027-03-22': '振替休日',
  '2027-04-29': '昭和の日',
  '2027-05-03': '憲法記念日',
  '2027-05-04': 'みどりの日',
  '2027-05-05': 'こどもの日',
  '2027-07-19': '海の日',
  '2027-08-11': '山の日',
  '2027-09-20': '敬老の日',
  '2027-09-23': '秋分の日',
  '2027-10-11': 'スポーツの日',
  '2027-11-03': '文化の日',
  '2027-11-23': '勤労感謝の日',
};

/** 祝日なら名称、平日なら null */
export function jpHolidayName(date: DateStr): string | null {
  return JP_HOLIDAYS[date] ?? null;
}

/** 土曜か(0=日,6=土) */
export function isSaturday(date: DateStr): boolean {
  return new Date(`${date}T00:00:00`).getDay() === 6;
}

export function isSunday(date: DateStr): boolean {
  return new Date(`${date}T00:00:00`).getDay() === 0;
}

/**
 * 土日祝の判定(振込の支払日チェック ■13/カレンダー配色 ■14 で共用)。
 * label は「土曜日」「日曜日」または祝日名
 */
export function weekendOrHoliday(date: DateStr): { label: string } | null {
  const holiday = jpHolidayName(date);
  if (holiday) return { label: `祝日(${holiday})` };
  if (isSaturday(date)) return { label: '土曜日' };
  if (isSunday(date)) return { label: '日曜日' };
  return null;
}
